import { useCallback, useState, useMemo, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Chip } from '@beeline/design-system-react/extracted-styles';

import { Categories as CatalogCategory } from ':types';
import { CategoriesSkeleton } from './components/Skeleton';
import { Error } from './components/Error';

import styles from './styles.module.scss';

interface CategoriesProps {
  items?: CatalogCategory[];
  error: boolean;
  isLoading: boolean;
  paramsCategoryId?: string;
  refetch: () => void;
}

export const Categories = ({
  isLoading,
  error,
  items,
  paramsCategoryId,
  refetch,
}: CategoriesProps) => {
  const navigate = useNavigate();
  const paramsCategory = useMemo(
    () =>
      items?.find(category => category.id.toString() === paramsCategoryId) ||
      null,
    [items, paramsCategoryId]
  );
  const [selectedCategory, setCategory] = useState<CatalogCategory | null>(
    paramsCategory
  );

  useEffect(() => setCategory(paramsCategory), [paramsCategory]);

  const onCategoryClick = useCallback(
    (category?: CatalogCategory) => () => {
      navigate(category ? `./${category.id}` : '', { replace: true });
      setCategory(category || null);
    },
    []
  );

  if (isLoading) return <CategoriesSkeleton />;
  if (error) return <Error refetch={refetch} />;

  return (
    <div className={styles.categories}>
      <Chip
        key='all'
        label='Все'
        onClick={onCategoryClick()}
        active={!selectedCategory}
      />
      {items?.map(category => (
        <Chip
          key={category.id}
          label={category.name}
          onClick={onCategoryClick(category)}
          active={selectedCategory?.id === category.id}
        />
      ))}
    </div>
  );
};
